import React, { Component } from 'react';

import { SCREEN_ID_JOIN_SUNROOM_CLUB_THANK_YOU } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import ButtonDeprecated from 'client/components/ButtonDeprecated';

@withTransitionHook
@withScreenId(SCREEN_ID_JOIN_SUNROOM_CLUB_THANK_YOU)
@withScrollToTop
class SunroomClubConfirmationPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Select - Thank You | Sunroom Rentals',
    keywords: 'sunroom, select, confirmation',
    description: 'Thanks for joining Sunroom Select!',
  });

  render() {
    return (
      <div>
        <div className="modal success">
          <div className="question-mark" />
          <div className="contentContainer">
            <div className="heroIcon checkmark" />
            <div className="textContainer">
              <span className="headline">Success!</span>
              <span className="explainer">
                {"We're reviewing your application now. " +
                  "We'll let you know if you get approved " +
                  'for Sunroom Select! We’ll refund you if ' +
                  'you’re not accepted.'}
              </span>
            </div>
            <ButtonDeprecated href="/explore/map">ok, view rentals</ButtonDeprecated>
          </div>
        </div>
      </div>
    );
  }
}

SunroomClubConfirmationPage.displayName = 'SunroomClubConfirmationPage';

export default SunroomClubConfirmationPage;
